'use client';

var MATCH_SCORE_UN_SUITABLE = 16;
var MATCH_SCORE_VERY_SUITABLE = 21;
var MATCH_SCORE_SKILL_PERCENT_POINT = 60;
var EMatching;
(function (EMatching) {
    EMatching["PENDING_FOR_QUERY"] = "PENDING_FOR_QUERY";
    EMatching["NOT_LOGIN"] = "NOT_LOGIN";
    EMatching["NOT_MATCHING"] = "NOT_MATCHING";
    EMatching["MATCHING"] = "MATCHING";
    EMatching["VERRY_MATCHING"] = "VERRY_MATCHING";
})(EMatching || (EMatching = {}));

export { EMatching, MATCH_SCORE_SKILL_PERCENT_POINT, MATCH_SCORE_UN_SUITABLE, MATCH_SCORE_VERY_SUITABLE };
//# sourceMappingURL=const.js.map
